__turbopack_context__.v({
  "badge-wrapper": "styles-module__etg6IW__badge-wrapper",
  "carousel-card": "styles-module__etg6IW__carousel-card",
  "carousel-fade": "styles-module__etg6IW__carousel-fade",
  "carousel-scroll-area": "styles-module__etg6IW__carousel-scroll-area",
  "flipping-icon": "styles-module__etg6IW__flipping-icon",
  "rounded-image-wrapper": "styles-module__etg6IW__rounded-image-wrapper",
});
